import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';
const url = 'categoria';

const LOADER_CATE = 'LOADER_CATE';
const SET_DATA_CATE = 'SET_DATA_CATE';
const SET_PAGE_CATE = 'SET_PAGE_CATE';
const SET_UPDATE_DATA_CATE ='SET_UPDATE_DATA_CATE';
const SET_BUSCADOR_CATE = 'SET_BUSCADOR_CATE';
const SET_FILTRO_CATE = 'SET_FILTRO_CATE';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_CATE, cargando: true});
    const store = getStore();
    const search = store.categoria.buscador;
    const filtro = store.categoria.filtro_categoria;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_CATE, cargando: false});
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_CATE, data});
            dispatch({type: SET_PAGE_CATE, page});
        }
        dispatch({type: LOADER_CATE, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_CATE, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CATE, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/admin_categorias'))
        }
    }).then((data) => {
        dispatch({type: LOADER_CATE, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_CATE, updateData: data});
            dispatch(initializeForm('categoria', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.categoria.values;
    dispatch({type: LOADER_CATE, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_CATE, cargando: false})
        Swal('Éxito', 'Se ha creado la categoria.', 'success')
        .then(() => {
            dispatch(push('/admin_categorias'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_CATE, cargando: false})
        Swal(
            'Error',
             (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_CATE, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.categoria.values);
    dispatch({type: LOADER_CATE, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_CATE, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/admin_categorias'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_CATE, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/admin_categorias'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_CATE, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CATE, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_CATE, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_CATE, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_CATE, filtro_categoria: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_CATE]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_CATE]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_CATE]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_CATE]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_CATE]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_CATE]: (state, { filtro_categoria }) => {
        return {...state, filtro_categoria }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_categoria: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
